import * as React from 'react';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';

import { ScrollProgressBar } from 'common/general';
import ArrowBoxIcon from 'vectors/icons/arrow-box.svg';
import { Button } from 'common/interaction';
import { MenuButton, MenuContainer, MenuContent, NNLogo, MenuButtonsContainer } from './styled';

export const Menu: React.FC<MenuProps> = ({ useSimpleMenu }) => {
  const location = useLocation();
  const isResult = location.pathname.includes('/result');

  const startTool = () => {
    navigate('/questions/userType');
  };

  return (
    <>
      <MenuContainer>
        <MenuContent>
          <a href="https://www.nn.nl/">
            <NNLogo aria-label="Nationale-Nederlanden - Home" />
          </a>
          {!useSimpleMenu && (
            <MenuButtonsContainer>
              <MenuButton
                onClick={startTool}
                id="button_start_calculation"
              >
                Bereken nu
              </MenuButton>

              <Button
                variant="secondary"
                href="https://www.nn.nl/Over-NationaleNederlanden/Duurzame-samenleving/Klimaat.htm"
                urlTarget="blank">
                  Meer over duurzame mobiliteit <ArrowBoxIcon />
              </Button>
            </MenuButtonsContainer>
          )}
        </MenuContent>
      </MenuContainer>
      {isResult && <ScrollProgressBar />}
    </>
  );
};

type MenuProps = {
  useSimpleMenu?: boolean;
};
